import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogClose} from '@angular/material/dialog';
import {Budget} from '../../interfaces';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';

@Component({
    template: `
        <div mat-dialog-content>
          <h2>Generated offers for: {{budget.budgetNr}}</h2>
          <div style="overflow-y: auto; max-height: 300px;">
            <div style="display: flex; position: sticky; top: 0; background-color: white; z-index: 10">
              <div style="width: 500px; border: 1px solid lightgray; padding: 10px;">
                <mat-label>Offer url</mat-label>
              </div>
              <div style="width: 300px; border: 1px solid lightgray; padding: 10px">
                <mat-label>Company</mat-label>
              </div>
              <div style="width: 100px; border: 1px solid lightgray; padding: 10px">
                <mat-label>Amount</mat-label>
              </div>
            </div>
            @for (o of budget.allOffers; track o) {
              <div style="display: flex">
                <div style="width: 500px; border: 1px solid lightgray; padding: 10px">
                  <a [href]="o.offerUrl" target="_blank">{{ o.offerUrl }}</a>
                </div>
                <div style="width: 300px; border: 1px solid lightgray; padding: 10px">
                  <span>{{o.companyName}}</span>
                </div>
                <div style="width: 100px; border: 1px solid lightgray; padding: 10px">
                  <span>{{o.amount| currency:budget && budget.export ? 'USD' : 'EUR'}}</span>
                </div>
              </div>
            }
          </div>
        </div>
        <div mat-dialog-actions align="end">
          <button mat-flat-button color="primary" mat-dialog-close>Close</button>
        </div>
        `,
    standalone: true,
    imports: [
        CommonModule,
        MatDialogContent,
        MatDialogActions,
        MatButtonModule,
        MatDialogClose,
        MatFormFieldModule
    ]
})
export class OffersHistoryDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public budget: Budget
    ) {}
}